import type { RootState } from 'store';

export default (state: RootState) => state.config;
